module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"btnCancel":"Annuler","btnSave":"Enregistrer"},"en":{"btnCancel":"Cancel","btnSave":"Save"}}')
  delete Component.options._Ctor
}
